/**
 * FIFA World Cup 2026 — competition rule.
 *
 * Identity: API-Football league.id = 1, season = 2026.
 * Wires the knockout-stage placeholder bracket so `injectKnockoutBracket`
 * seeds R32 → Final placeholder cards until the API publishes real fixtures.
 */

import { WORLD_CUP_2026_BRACKET } from '../brackets/worldCup2026Bracket';
import type { CompetitionRule } from '../types';

const rule: CompetitionRule = {
  leagueCode: '1',
  season: '2026',
  bracket: WORLD_CUP_2026_BRACKET,
};

export default rule;
